module.exports = __webpack_public_path__ + "static/media/image_10.b6ad752c.png";